import m from "./../../../dist/es2015/themes/Kxy.js";
export const am5themes_Kxy = m;